import { render, staticRenderFns } from "./Redeem.vue?vue&type=template&id=2b6a9122"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"
import style0 from "./Redeem.vue?vue&type=style&index=0&id=2b6a9122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports